<template>
  <div>
    <div v-if="!empresaSelecionada">
      <div class="alert alert-danger" role="alert">
        Selecione uma empresa para continuar.
      </div>
    </div>
    <div v-if="empresaSelecionada" class="mov row">
      <div class="col-12">
        <h5 class="text-orange">
          <span class="mr-2">
            {{ empresaSelecionada.nomeFantasia }}
          </span>
        </h5>
      </div>

      <accordion
        v-for="accordion in gerarTelas()"
        :id="accordion.componente"
        :key="accordion.componente"
        :title="accordion.titulo"
        :hideTitle="accordion.esconderTitulo && !id"
        @abriu="abriu(accordion.componente)"
        class="col-12 mt-3"
      >
        <componentes
          :componente="accordion.componente"
          :empresa-id="empresaSelecionada.id"
          :ref="accordion.componente"
        />
      </accordion>
    </div>
  </div>
</template>
<script>
import Accordion from "@/components/card/Accordion";
import Componentes from "./Componentes";
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";
import ComponentesConfig from "./componentes.config";

export default {
  name: "MovimentacaoFinanceira",
  mixins: [AlertasMixin],
  components: {
    Accordion,
    Componentes,
  },
  data: () => ({}),
  methods: {
    abriu: function (tela) {
      /* eslint-disable */
      try {
        this.$refs[tela][0].montar(tela);
      } catch (e) {}
    },
    gerarTelas: function () {
      if (!this.empresaSelecionada) return [];
      return ComponentesConfig.filter((el) => {
        return this.permissao(el.chavePermissao).r;
      });
    },
  },
  mounted() {
    this.$store.dispatch(DEFINIR_BREADCRUMB, [
      {
        titulo: "Movimentação financeira",
        to: { name: "movimentacao-financeira" },
      },
    ]);
  },
  computed: {
    empresaSelecionada: function () {
      return this.$store.state.app.selectedCompanyObj;
    },
    permissao() {
      return this.$store.getters["app/retornaPermissao"];
    },
  },
};
</script>
<style lang="scss">
.mov table td,
.mov table th,
.mov .table td,
.mov .table th {
  white-space: nowrap;
}

.mov .b-table-stacked table td,
.mov .b-table-stacked table th,
.mov .b-table-stacked .table td,
.mov .b-table-stacked .table th {
  white-space: normal;
}
</style>